import React from 'react';
import ExpansionTableRowGroup from 'emerald-ui/lib/ExpansionTableRowGroup';
import TableHeader from 'emerald-ui/lib/TableHeader';
import ExpansionTableRow from 'emerald-ui/lib/ExpansionTableRow';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs(
    [
      {
        component: ExpansionTableRowGroup,
        componentName: 'ExpansionTableRowGroup',
      },
    ],
    'ExpansionTableRowGroup'
  ),
  description: (
    <span>
      Controls the expansion state of several <span className="code">ExpansionTableRow</span> components. It receives
      ExpansionTableRow as children.
    </span>
  ),
  codeSamples: [
    {
      title: 'Alternative summary',
      scope: { ExpansionTableRow, ExpansionTableRowGroup, TableHeader },
      code: `<div style={{ padding: '0 20px', overflow:'auto' }}>
  <ExpansionTableRowGroup id="g1">
    <TableHeader checkboxAriaLabel="Name">
      <th>Name</th>
      <th>Occupation</th>
      <th>Additional field</th>
    </TableHeader>
    <ExpansionTableRow>
      <ExpansionTableRow.Summary
        customId="firstRow"
        checkboxAriaLabel="John Done">
        <td>John Doe</td>
        <td>Marketing Assistant</td>
        <td>Some field 1</td>
      </ExpansionTableRow.Summary>
      <ExpansionTableRow.AlternativeSummary>
        <div>Information about John Doe</div>
      </ExpansionTableRow.AlternativeSummary>
      <ExpansionTableRow.Content>
        <div>
          <h1>This is a header for the row #1</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
        </div>
      </ExpansionTableRow.Content>
    </ExpansionTableRow>
    <ExpansionTableRow>
      <ExpansionTableRow.Summary
        customId="secondRow"
        checkboxAriaLabel="Mark Weaver">
        <td>Mark Weaver</td>
        <td>Marketing Assistant</td>
        <td>Sports</td>
      </ExpansionTableRow.Summary>
      <ExpansionTableRow.AlternativeSummary>
        <div>Information about Mark Weaver</div>
      </ExpansionTableRow.AlternativeSummary>
      <ExpansionTableRow.Content>
        <div>
          <h1>This is a header for the row #2</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
        </div>
      </ExpansionTableRow.Content>
    </ExpansionTableRow>
    <ExpansionTableRow>
      <ExpansionTableRow.Summary
        customId="thirdRow"
        checkboxAriaLabel="Jane Done">
        <td>Jane Doe</td>
        <td>Marketing Assistant</td>
        <td>Whatever</td>
      </ExpansionTableRow.Summary>
      <ExpansionTableRow.AlternativeSummary>
        <div>Information about Jane Doe</div>
      </ExpansionTableRow.AlternativeSummary>
      <ExpansionTableRow.Content>
        <div>
          <h1>This is a header for the row #3</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
        </div>
      </ExpansionTableRow.Content>
    </ExpansionTableRow>
    <ExpansionTableRow>
      <ExpansionTableRow.Summary
        customId="fourthRow"
        checkboxAriaLabel="John Appleseed">
        <td>John Appleseed</td>
        <td>Marketing Assistant</td>
        <td>Whatever</td>
      </ExpansionTableRow.Summary>
      <ExpansionTableRow.AlternativeSummary>
        <div>Information about John Appleseed</div>
      </ExpansionTableRow.AlternativeSummary>
      <ExpansionTableRow.Content>
        <div>
          <h1>This is a header for the row #4</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
        </div>
      </ExpansionTableRow.Content>
    </ExpansionTableRow>
  </ExpansionTableRowGroup>
</div>`,
    },
  ],
};
